/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../../../common";
import type {
  BondAggregator,
  BondAggregatorInterface,
} from "../../../../contracts/test/BondAggregator.mock.sol/BondAggregator";

const _abi = [
  {
    inputs: [],
    name: "auctioneer",
    outputs: [
      {
        internalType: "contract IBondAuctioneer",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "firstIndex_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lastIndex_",
        type: "uint256",
      },
    ],
    name: "closingMarketsBetween",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "currentCapacity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "payout_",
        type: "address",
      },
      {
        internalType: "address",
        name: "quote_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountIn_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minAmountOut_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxExpiry_",
        type: "uint256",
      },
    ],
    name: "findMarketFor",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "getAuctioneer",
    outputs: [
      {
        internalType: "contract IBondAuctioneer",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "getTeller",
    outputs: [
      {
        internalType: "contract IBondTeller",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "isClosing",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "isInstantSwap",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "isLive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "firstIndex_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lastIndex_",
        type: "uint256",
      },
    ],
    name: "liveMarketsBetween",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "firstIndex_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lastIndex_",
        type: "uint256",
      },
    ],
    name: "liveMarketsBy",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token_",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isPayout_",
        type: "bool",
      },
    ],
    name: "liveMarketsFor",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "marketPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
    ],
    name: "marketScale",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "payout_",
        type: "address",
      },
      {
        internalType: "address",
        name: "quote_",
        type: "address",
      },
    ],
    name: "marketsFor",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "referrer_",
        type: "address",
      },
    ],
    name: "maxAmountAccepted",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "referrer_",
        type: "address",
      },
    ],
    name: "payoutFor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "price",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "scale",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IBondAuctioneer",
        name: "auct_",
        type: "address",
      },
      {
        internalType: "contract IBondTeller",
        name: "teller_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "price_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "scale_",
        type: "uint256",
      },
    ],
    name: "setParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "teller",
    outputs: [
      {
        internalType: "contract IBondTeller",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type BondAggregatorConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BondAggregatorConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class BondAggregator__factory extends ContractFactory {
  constructor(...args: BondAggregatorConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      BondAggregator & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): BondAggregator__factory {
    return super.connect(runner) as BondAggregator__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BondAggregatorInterface {
    return new Interface(_abi) as BondAggregatorInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): BondAggregator {
    return new Contract(address, _abi, runner) as unknown as BondAggregator;
  }
}
